<div class="min-h-screen min-w-screen bg-surface-v2">
  <router-outlet></router-outlet>
</div>
